import SolicitacaoCompra from './componentes/SolicitacaoCompra.vue';
import SolicitacaoCompraLista from './componentes/SolicitacaoCompraLista.vue';
import SolicitacaoCompraForm from './componentes/SolicitacaoCompraForm.vue';
import SolicitacaoCompraRelatorio from './componentes/SolicitacaoCompraRelatorio.vue';

export default {
  path: '/solicitacao-compra',
  component: SolicitacaoCompra,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoCompraLista,
      name: 'solicitacao-compra',
    },
    {
      path: 'nova',
      component: SolicitacaoCompraForm,
      name: 'solicitacao-compra.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoCompraRelatorio,
      name: 'solicitacao-compra.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoCompraForm,
      name: 'solicitacao-compra.editar'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-compra/rotas.js